const translation = {
  translation: {
    "Malts": "Fermentables",
    "Nom": "Name",
    "Quantité": "Quantity",
    "NoMalts": "No fermentables added for this recipe."
  },
};

export default translation;